import './Banners.css'
import { getFrontendAssetUrl } from '../../lib/frontendAssets';

const bannerGaming = getFrontendAssetUrl('gamingBanner.jpg');

const Banners = () => {
    return(
        <section className="banners">
            <div className="banner principal-banner">
                <h2>Monta el teu propi PC Gaming!!</h2>
                <p>Escull les peces, nosaltres el montem per tu!</p>
                <p>100% personalitzat</p>
                <button className="buttonC">Consultar</button>
                <img src={bannerGaming} className='product-images' alt="PC gaming" />

            </div>
            <div className="side-banners">
                <div className="banner serveiTecnic-banner">
                    <h2>Servei Tècnic personalitzat</h2>
                    <p>El teu PC va lent o et dona problemes?</p>
                    <p>La teva impresora no imprimeix correctament?</p>
                    <h2>Porta'ns-el i t'ho arreglem en un pim pam</h2>
                    <button className="buttonC">Consultar</button>
                </div>
                <div className="banner garantia-banner">
                    <h2>Garantia 3 mesos en reparacions!</h2>
                    <p>Amb la compra de qualsevol dels nostres productes tens una garantia asegurada!</p>
                    <p>Nota: Ha de ser un producte comprat a la nostra botiga</p>
                    <p>Nota: La garantia només aplica davant fallades del programari</p>
                    <p>Nota: Caigudes, cops, begudes/aigua sobre els dispositius, mal ús.. no entren</p>
                    <p>Nota: No entren consumibles ni productes que s'hagin de consumir per fer ús</p>
                    <button className="buttonC">Consultar</button>
                </div>
                
            </div>
        </section>
        
    )
}

export default Banners